import { render, staticRenderFns } from "./SG.vue?vue&type=template&id=26785759&scoped=true&"
import script from "./SG.js?vue&type=script&lang=js&"
export * from "./SG.js?vue&type=script&lang=js&"
import style0 from "./SG.vue?vue&type=style&index=0&id=26785759&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26785759",
  null
  
)

export default component.exports